;(function () {
  /**
   * HiPrint 打印组件全局配置
   * 该配置定义了打印设计器的各种选项和组件配置
   */
  window.HIPRINT_CONFIG = {
    //optionItems: [hiprintCustomOptionItem], // 自定义选项项

    // ================ 全局设置 ================
    movingDistance: 1.5, // 鼠标拖动一次移动的距离，默认1.5pt，控制元素拖拽的精度
    paperHeightTrim: 1, // 纸张HTML的高度等于真实高度减去的值，用于调整显示偏差
    showPosition: true, // 是否显示坐标位置，方便开发调试
    positionLineMode: true, // 坐标是否显示在线上，false表示显示在角落
    positionUnit: true, // 是否显示坐标单位（pt）
    showSizeBox: true, // 是否显示宽高提示框
    adsorbMin: 3, // 吸附最小距离pt，元素间距离小于此值时会自动吸附对齐
    showAdsorbLine: true, // 是否显示吸附线，帮助用户对齐元素
    adsorbLineMin: 6, // 吸附线显示最小距离pt，距离小于此值时显示吸附线
    paperNumberContinue: true, // 连续打印时页码是否连续

    // ================ 面板配置 ================
    panel: {
      /**
       * 面板支持的选项列表
       * 每个选项控制面板中对应功能的显示/隐藏
       */
      supportOptions: [
        {
          name: 'panelPaperRule', // 纸张标尺设置
          hidden: false,
        },
        {
          name: 'panelPageRule', // 页面标尺设置
          hidden: false,
        },
        {
          name: 'firstPaperFooter', // 首页页脚设置
          hidden: false,
        },
        {
          name: 'evenPaperFooter', // 偶数页页脚设置
          hidden: false,
        },
        {
          name: 'oddPaperFooter', // 奇数页页脚设置
          hidden: false,
        },
        {
          name: 'lastPaperFooter', // 末页页脚设置
          hidden: false,
        },
        {
          name: 'leftOffset', // 左边距设置
          hidden: false,
        },
        {
          name: 'topOffset', // 上边距设置
          hidden: false,
        },
        {
          name: 'fontFamily', // 字体族设置
          hidden: false,
        },
        {
          name: 'orient', // 页面方向设置（横向/纵向）
          hidden: false,
        },
        {
          name: 'paperNumberDisabled', // 是否禁用页码
          hidden: false,
        },
        {
          name: 'paperNumberContinue', // 页码是否连续
          hidden: false,
        },
        {
          name: 'paperNumberFormat', // 页码格式设置
          hidden: false,
        },
        {
          name: 'watermarkOptions', // 水印选项设置
          hidden: false,
        },
        {
          name: 'panelLayoutOptions', // 面板布局选项
          hidden: false,
        },
      ],
      default: {}, // 面板默认配置
    },

    // ================ 文本组件配置 ================
    text: {
      /**
       * 文本组件的选项卡配置
       * 将相关选项分组到不同的选项卡中，提供更好的用户体验
       */
      tabs: [
        {
          name: '基础', // 基础属性选项卡
          options: [
            {
              name: 'title', // 元素标题/名称
              hidden: false,
            },
            {
              name: 'field', // 数据字段绑定
              hidden: true,
            },
            {
              name: 'testData', // 测试数据
              hidden: false,
            },
            {
              name: 'coordinate', // 坐标位置（x, y）
              hidden: false,
            },
            {
              name: 'widthHeight', // 宽度和高度
              hidden: false,
            },
            {
              name: 'hideTitle', // 是否隐藏标题
              hidden: false,
            },
            {
              name: 'fixed', // 是否固定位置（不跟随数据变化）
              hidden: false,
            },
          ],
        },
        {
          name: '样式', // 样式属性选项卡
          options: [
            {
              name: 'dataType', // 数据类型（文本、数字、日期等）
              hidden: false,
            },
            {
              name: 'fontFamily', // 字体族
              hidden: false,
            },
            {
              name: 'fontSize', // 字体大小
              hidden: false,
            },
            {
              name: 'fontWeight', // 字体粗细（normal, bold等）
              hidden: false,
            },
            {
              name: 'letterSpacing', // 字符间距
              hidden: false,
            },
            {
              name: 'color', // 文字颜色
              hidden: false,
            },
            {
              name: 'backgroundColor', // 背景颜色
              hidden: false,
            },
            {
              name: 'textDecoration', // 文字装饰（下划线、删除线等）
              hidden: false,
            },
            {
              name: 'textAlign', // 水平对齐方式（左、中、右）
              hidden: false,
            },
            {
              name: 'textContentVerticalAlign', // 垂直对齐方式
              hidden: false,
            },
            {
              name: 'textContentWrap', // 文字换行设置
              hidden: false,
            },
            {
              name: 'lineHeight', // 行高
              hidden: false,
            },
            {
              name: 'transform', // 变换效果（旋转、缩放等）
              hidden: false,
            },
            {
              name: 'zIndex', // 层级顺序
              hidden: false,
            },
          ],
        },
        {
          name: '边框', // 边框属性选项卡
          options: [
            {
              name: 'optionsGroup', // 选项组
              hidden: false,
            },
            {
              name: 'borderLeft', // 左边框
              hidden: false,
            },
            {
              name: 'borderTop', // 上边框
              hidden: false,
            },
            {
              name: 'borderRight', // 右边框
              hidden: false,
            },
            {
              name: 'borderBottom', // 下边框
              hidden: false,
            },
            {
              name: 'borderWidth', // 边框宽度
              hidden: false,
            },
            {
              name: 'borderColor', // 边框颜色
              hidden: false,
            },
            {
              name: 'contentPaddingLeft', // 内容左内边距
              hidden: false,
            },
            {
              name: 'contentPaddingTop', // 内容上内边距
              hidden: false,
            },
            {
              name: 'contentPaddingRight', // 内容右内边距
              hidden: false,
            },
            {
              name: 'contentPaddingBottom', // 内容下内边距
              hidden: false,
            },
          ],
        },
        {
          name: '高级', // 高级功能选项卡
          options: [
            {
              name: 'textType', // 文本类型（普通文本、条形码、二维码等）
              hidden: false,
            },
            {
              name: 'barcodeMode', // 条形码模式/类型
              hidden: false,
            },
            {
              name: 'barTextMode', // 条形码文字显示模式
              hidden: false,
            },
            {
              name: 'barWidth', // 条形码宽度
              hidden: false,
            },
            {
              name: 'barAutoWidth', // 条形码自动宽度
              hidden: false,
            },
            {
              name: 'qrCodeLevel', // 二维码错误纠正级别
              hidden: false,
            },
            {
              name: 'pageBreak', // 分页设置
              hidden: false,
            },
            {
              name: 'showInPage', // 显示在指定页面
              hidden: false,
            },
            {
              name: 'unShowInPage', // 不显示在指定页面
              hidden: false,
            },
            {
              name: 'axis', // 坐标轴设置
              hidden: false,
            },
            {
              name: 'upperCase', // 大写转换
              hidden: false,
            },
            {
              name: 'formatter', // 格式化函数
              hidden: false,
            },
            {
              name: 'styler', // 样式函数
              hidden: false,
            },
          ],
        },
      ],
      /**
       * 文本组件支持的所有选项
       * 这里列出了文本组件可以配置的所有属性
       */
      supportOptions: [
        {
          name: 'title', // 元素标题/名称
          hidden: false,
        },
        {
          name: 'field', // 数据字段绑定
          hidden: true,
        },
        {
          name: 'testData', // 测试数据
          hidden: false,
        },
        {
          name: 'coordinate', // 坐标位置（x, y）
          hidden: false,
        },
        {
          name: 'widthHeight', // 宽度和高度
          hidden: false,
        },
        {
          name: 'dataType', // 数据类型
          hidden: false,
        },
        {
          name: 'fontFamily', // 字体族
          hidden: false,
        },
        {
          name: 'fontSize', // 字体大小
          hidden: false,
        },
        {
          name: 'fontWeight', // 字体粗细
          hidden: false,
        },
        {
          name: 'letterSpacing', // 字符间距
          hidden: false,
        },
        {
          name: 'color', // 文字颜色
          hidden: false,
        },
        {
          name: 'textDecoration', // 文字装饰
          hidden: false,
        },
        {
          name: 'textAlign', // 水平对齐
          hidden: false,
        },
        {
          name: 'textContentVerticalAlign', // 垂直对齐
          hidden: false,
        },
        {
          name: 'textContentWrap', // 文字换行
          hidden: false,
        },
        {
          name: 'lineHeight', // 行高
          hidden: false,
        },
        {
          name: 'textType', // 文本类型
          hidden: false,
        },
        {
          name: 'barcodeMode', // 条形码模式
          hidden: false,
        },
        {
          name: 'barTextMode', // 条形码文字模式
          hidden: false,
        },
        {
          name: 'barWidth', // 条形码宽度
          hidden: false,
        },
        {
          name: 'barAutoWidth', // 条形码自动宽度
          hidden: false,
        },
        {
          name: 'qrCodeLevel', // 二维码纠错级别
          hidden: false,
        },
        {
          name: 'hideTitle', // 隐藏标题
          hidden: false,
        },
        {
          name: 'pageBreak', // 分页
          hidden: false,
        },
        {
          name: 'showInPage', // 显示在指定页面
          hidden: false,
        },
        {
          name: 'unShowInPage', // 不显示在指定页面
          hidden: false,
        },
        {
          name: 'fixed', // 固定位置
          hidden: false,
        },
        {
          name: 'axis', // 坐标轴
          hidden: false,
        },
        {
          name: 'transform', // 变换效果
          hidden: false,
        },
        {
          name: 'zIndex', // 层级
          hidden: false,
        },
        {
          name: 'optionsGroup', // 选项组
          hidden: false,
        },
        {
          name: 'borderLeft', // 左边框
          hidden: false,
        },
        {
          name: 'borderTop', // 上边框
          hidden: false,
        },
        {
          name: 'borderRight', // 右边框
          hidden: false,
        },
        {
          name: 'borderBottom', // 下边框
          hidden: false,
        },
        {
          name: 'borderWidth', // 边框宽度
          hidden: false,
        },
        {
          name: 'borderColor', // 边框颜色
          hidden: false,
        },
        {
          name: 'contentPaddingLeft', // 内容左内边距
          hidden: false,
        },
        {
          name: 'contentPaddingTop', // 内容上内边距
          hidden: false,
        },
        {
          name: 'contentPaddingRight', // 内容右内边距
          hidden: false,
        },
        {
          name: 'contentPaddingBottom', // 内容下内边距
          hidden: false,
        },
        {
          name: 'backgroundColor', // 背景颜色
          hidden: false,
        },
        {
          name: 'formatter', // 格式化函数
          hidden: false,
        },
        {
          name: 'styler', // 样式函数
          hidden: false,
        },
      ],
      /**
       * 文本组件默认配置
       */
      default: {
        width: 120, // 默认宽度
        height: 16, // 默认高度
        textContentVerticalAlign: 'middle', // 垂直居中
        // barAutoWidth: 'true' // 条形码自动宽度，这里必须使用字符串
      },
    },

    // ================ 图片组件配置 ================
    image: {
      /**
       * 图片组件的选项卡配置
       */
      tabs: [
        {
          name: '基础', // 基础属性选项卡
          options: [
            {
              name: 'field', // 数据字段绑定
              hidden: true,
            },
            {
              name: 'src', // 图片源地址
              hidden: false,
            },
            {
              name: 'fit', // 图片适配方式（缩放、拉伸等）
              hidden: false,
            },
            {
              name: 'coordinate', // 坐标位置
              hidden: false,
            },
            {
              name: 'widthHeight', // 宽度和高度
              hidden: false,
            },
            {
              name: 'showInPage', // 显示在指定页面
              hidden: false,
            },
            {
              name: 'unShowInPage', // 不显示在指定页面
              hidden: false,
            },
            {
              name: 'fixed', // 固定位置
              hidden: false,
            },
          ],
        },
        {
          name: '样式', // 样式属性选项卡
          options: [
            {
              name: 'transform', // 变换效果
              hidden: false,
            },
            {
              name: 'zIndex', // 层级顺序
              hidden: false,
            },
            {
              name: 'borderRadius', // 边框圆角
              hidden: false,
            },
          ],
        },
        {
          name: '高级', // 高级功能选项卡
          options: [
            {
              name: 'pageBreak', // 分页设置
              hidden: false,
            },
            {
              name: 'axis', // 坐标轴设置
              hidden: false,
            },
            {
              name: 'formatter', // 格式化函数
              hidden: false,
            },
            {
              name: 'styler', // 样式函数
              hidden: false,
            },
          ],
        },
      ],
      /**
       * 图片组件支持的所有选项
       */
      supportOptions: [
        {
          name: 'field', // 数据字段绑定
          hidden: true,
        },
        {
          name: 'src', // 图片源地址
          hidden: false,
        },
        {
          name: 'fit', // 图片适配方式
          hidden: false,
        },
        {
          name: 'borderRadius', // 边框圆角
          hidden: false,
        },
        {
          name: 'coordinate', // 坐标位置
          hidden: false,
        },
        {
          name: 'widthHeight', // 宽度和高度
          hidden: false,
        },
        {
          name: 'showInPage', // 显示在指定页面
          hidden: false,
        },
        {
          name: 'unShowInPage', // 不显示在指定页面
          hidden: false,
        },
        {
          name: 'fixed', // 固定位置
          hidden: false,
        },
        {
          name: 'pageBreak', // 分页设置
          hidden: false,
        },
        {
          name: 'axis', // 坐标轴设置
          hidden: false,
        },
        {
          name: 'transform', // 变换效果
          hidden: false,
        },
        {
          name: 'zIndex', // 层级顺序
          hidden: false,
        },
        {
          name: 'formatter', // 格式化函数
          hidden: false,
        },
        {
          name: 'styler', // 样式函数
          hidden: false,
        },
      ],
      /**
       * 图片组件默认配置
       */
      default: {
        width: 50,
        height: 50,
      },
    },

    // ================ 长文本组件配置 ================
    longText: {
      /**
       * 长文本组件的选项卡配置
       * 长文本组件用于显示多行文本内容，支持自动换行和分页
       */
      tabs: [
        {
          name: '基础', // 基础属性选项卡
          options: [
            {
              name: 'title', // 元素标题/名称
              hidden: false,
            },
            {
              name: 'field', // 数据字段绑定
              hidden: true,
            },
            {
              name: 'testData', // 测试数据
              hidden: false,
            },
            {
              name: 'coordinate', // 坐标位置
              hidden: false,
            },
            {
              name: 'widthHeight', // 宽度和高度
              hidden: false,
            },
            {
              name: 'hideTitle', // 是否隐藏标题
              hidden: false,
            },
            {
              name: 'fixed', // 是否固定位置
              hidden: false,
            },
          ],
        },
        {
          name: '样式', // 样式属性选项卡
          options: [
            {
              name: 'fontFamily', // 字体族
              hidden: false,
            },
            {
              name: 'fontSize', // 字体大小
              hidden: false,
            },
            {
              name: 'fontWeight', // 字体粗细
              hidden: false,
            },
            {
              name: 'letterSpacing', // 字符间距
              hidden: false,
            },
            {
              name: 'textAlign', // 文本对齐方式
              hidden: false,
            },
            {
              name: 'lineHeight', // 行高
              hidden: false,
            },
            {
              name: 'color', // 文字颜色
              hidden: false,
            },
            {
              name: 'longTextIndent', // 长文本首行缩进
              hidden: false,
            },
            {
              name: 'leftSpaceRemoved', // 移除左侧空格
              hidden: false,
            },
            {
              name: 'lHeight', // 行高度设置
              hidden: false,
            },
            {
              name: 'transform', // 变换效果
              hidden: false,
            },
            {
              name: 'zIndex', // 层级顺序
              hidden: false,
            },
          ],
        },
        {
          name: '高级', // 高级功能选项卡
          options: [
            {
              name: 'pageBreak', // 分页设置
              hidden: false,
            },
            {
              name: 'showInPage', // 显示在指定页面
              hidden: false,
            },
            {
              name: 'unShowInPage', // 不显示在指定页面
              hidden: false,
            },
            {
              name: 'axis', // 坐标轴设置
              hidden: false,
            },
            {
              name: 'formatter', // 格式化函数
              hidden: false,
            },
            {
              name: 'styler', // 样式函数
              hidden: false,
            },
          ],
        },
      ],
      /**
       * 长文本组件支持的所有选项
       */
      supportOptions: [
        {
          name: 'title', // 元素标题/名称
          hidden: false,
        },
        {
          name: 'field', // 数据字段绑定
          hidden: true,
        },
        {
          name: 'testData', // 测试数据
          hidden: false,
        },
        {
          name: 'coordinate', // 坐标位置
          hidden: false,
        },
        {
          name: 'widthHeight', // 宽度和高度
          hidden: false,
        },
        {
          name: 'fontFamily', // 字体族
          hidden: false,
        },
        {
          name: 'fontSize', // 字体大小
          hidden: false,
        },
        {
          name: 'fontWeight', // 字体粗细
          hidden: false,
        },
        {
          name: 'letterSpacing', // 字符间距
          hidden: false,
        },
        {
          name: 'textAlign', // 文本对齐方式
          hidden: false,
        },
        {
          name: 'lineHeight', // 行高
          hidden: false,
        },
        {
          name: 'color', // 文字颜色
          hidden: false,
        },
        {
          name: 'hideTitle', // 隐藏标题
          hidden: false,
        },
        {
          name: 'longTextIndent', // 长文本首行缩进
          hidden: false,
        },
        {
          name: 'leftSpaceRemoved', // 移除左侧空格
          hidden: false,
        },
        {
          name: 'pageBreak', // 分页设置
          hidden: false,
        },
        {
          name: 'showInPage', // 显示在指定页面
          hidden: false,
        },
        {
          name: 'unShowInPage', // 不显示在指定页面
          hidden: false,
        },
        {
          name: 'fixed', // 固定位置
          hidden: false,
        },
        {
          name: 'axis', // 坐标轴设置
          hidden: false,
        },
        {
          name: 'lHeight', // 行高度设置
          hidden: false,
        },
        {
          name: 'transform', // 变换效果
          hidden: false,
        },
        {
          name: 'zIndex', // 层级顺序
          hidden: false,
        },
        {
          name: 'optionsGroup', // 选项组
          hidden: false,
        },
        {
          name: 'borderLeft', // 左边框
          hidden: false,
        },
        {
          name: 'borderTop', // 上边框
          hidden: false,
        },
        {
          name: 'borderRight', // 右边框
          hidden: false,
        },
        {
          name: 'borderBottom', // 下边框
          hidden: false,
        },
        {
          name: 'borderWidth', // 边框宽度
          hidden: false,
        },
        {
          name: 'borderColor', // 边框颜色
          hidden: false,
        },
        {
          name: 'contentPaddingLeft', // 内容左内边距
          hidden: false,
        },
        {
          name: 'contentPaddingTop', // 内容上内边距
          hidden: false,
        },
        {
          name: 'contentPaddingRight', // 内容右内边距
          hidden: false,
        },
        {
          name: 'contentPaddingBottom', // 内容下内边距
          hidden: false,
        },
        {
          name: 'backgroundColor', // 背景颜色
          hidden: false,
        },
        {
          name: 'formatter', // 格式化函数
          hidden: false,
        },
        {
          name: 'styler', // 样式函数
          hidden: false,
        },
      ],
      /**
       * 长文本组件默认配置
       */
      default: {
        height: 32, // 默认高度
        width: 200, // 默认宽度
      },
    },

    // ================ 表格组件配置 ================
    table: {
      /**
       * 表格组件的选项卡配置
       * 表格组件用于显示表格数据，支持表头重复、分页、自动补全等功能
       */
      tabs: [
        {
          name: '基础', // 基础属性选项卡
          options: [
            {
              name: 'field', // 数据字段绑定
              hidden: true,
            },
            {
              name: 'testData', // 测试数据
              hidden: false,
            },
            {
              name: 'coordinate', // 坐标位置
              hidden: false,
            },
            {
              name: 'widthHeight', // 宽度和高度
              hidden: false,
            },
            {
              name: 'tableHeaderRepeat', // 表头重复显示
              hidden: false,
            },
            {
              name: 'tableFooterRepeat', // 表尾重复显示
              hidden: false,
            },
            {
              name: 'autoCompletion', // 自动补全
              hidden: false,
            },
            {
              name: 'maxRows', // 最大行数
              hidden: false,
            },
            {
              name: 'columns', // 表格列配置
              hidden: false,
            },
          ],
        },
        {
          name: '样式', // 样式属性选项卡
          options: [
            {
              name: 'fontFamily', // 字体族
              hidden: false,
            },
            {
              name: 'fontSize', // 字体大小
              hidden: false,
            },
            {
              name: 'lineHeight', // 行高
              hidden: false,
            },
            {
              name: 'textAlign', // 文本对齐方式
              hidden: false,
            },
            {
              name: 'gridColumns', // 网格列配置
              hidden: false,
            },
            {
              name: 'gridColumnsGutter', // 网格列间距
              hidden: false,
            },
            {
              name: 'tableBorder', // 表格边框
              hidden: false,
            },
            {
              name: 'tableHeaderBorder', // 表头边框
              hidden: false,
            },
            {
              name: 'tableHeaderCellBorder',
              hidden: false,
            },
            {
              name: 'tableHeaderRowHeight',
              hidden: false,
            },
            {
              name: 'tableHeaderBackground',
              hidden: false,
            },
            {
              name: 'tableHeaderFontSize',
              hidden: false,
            },
            {
              name: 'tableHeaderFontWeight',
              hidden: false,
            },
            {
              name: 'tableBodyRowHeight',
              hidden: false,
            },
            {
              name: 'tableBodyRowBorder',
              hidden: false,
            },
            {
              name: 'tableBodyCellBorder',
              hidden: false,
            },
            {
              name: 'tableFooterBorder',
              hidden: false,
            },
            {
              name: 'tableFooterCellBorder',
              hidden: false,
            },
            {
              name: 'lHeight',
              hidden: false,
            },
          ],
        },
        // 留空即显示 表格 列 属性
        {
          name: '列',
          options: [],
        },
        {
          name: '高级',
          options: [
            {
              name: 'axis',
              hidden: false,
            },
            {
              name: 'styler',
              hidden: false,
            },
            {
              name: 'rowStyler',
              hidden: false,
            },
            {
              name: 'footerFormatter',
              hidden: false,
            },
            {
              name: 'rowsColumnsMerge',
              hidden: false,
            },
            {
              name: 'rowsColumnsMergeClean',
              hidden: false,
            },
            {
              name: 'groupSequenceContinue',
              hidden: false,
            },
            {
              name: 'groupFieldsFormatter',
              hidden: false,
            },
            {
              name: 'groupFormatter',
              hidden: false,
            },
            {
              name: 'groupFooterFormatter',
              hidden: false,
            },
            {
              name: 'gridColumnsFooterFormatter',
              hidden: false,
            },
          ],
        },
      ],
      supportOptions: [
        {
          name: 'field',
          hidden: true,
        },
        {
          name: 'coordinate',
          hidden: false,
        },
        {
          name: 'widthHeight',
          hidden: false,
        },
        {
          name: 'fontFamily',
          hidden: false,
        },
        {
          name: 'fontSize',
          hidden: false,
        },
        {
          name: 'lineHeight',
          hidden: false,
        },
        {
          name: 'textAlign',
          hidden: false,
        },
        {
          name: 'gridColumns',
          hidden: false,
        },
        {
          name: 'gridColumnsGutter',
          hidden: false,
        },
        {
          name: 'tableHeaderRepeat',
          hidden: false,
        },
        {
          name: 'tableBorder',
          hidden: false,
        },
        {
          name: 'tableHeaderBorder',
          hidden: false,
        },
        {
          name: 'tableHeaderCellBorder',
          hidden: false,
        },
        {
          name: 'tableHeaderRowHeight',
          hidden: false,
        },
        {
          name: 'tableHeaderBackground',
          hidden: false,
        },
        {
          name: 'tableHeaderFontSize',
          hidden: false,
        },
        {
          name: 'tableHeaderFontWeight',
          hidden: false,
        },
        {
          name: 'tableBodyRowHeight',
          hidden: false,
        },
        {
          name: 'tableBodyRowBorder',
          hidden: false,
        },
        {
          name: 'tableBodyCellBorder',
          hidden: false,
        },
        {
          name: 'tableFooterBorder',
          hidden: false,
        },
        {
          name: 'tableFooterCellBorder',
          hidden: false,
        },
        {
          name: 'axis',
          hidden: false,
        },
        {
          name: 'lHeight',
          hidden: false,
        },
        {
          name: 'autoCompletion',
          hidden: false,
        },
        {
          name: 'maxRows',
          hidden: false,
        },
        {
          name: 'columns',
          hidden: false,
        },
        {
          name: 'styler',
          hidden: false,
        },
        {
          name: 'rowStyler',
          hidden: false,
        },
        {
          name: 'tableFooterRepeat',
          hidden: false,
        },
        {
          name: 'footerFormatter',
          hidden: false,
        },
        {
          name: 'rowsColumnsMerge',
          hidden: false,
        },
        {
          name: 'rowsColumnsMergeClean',
          hidden: false,
        },
        {
          name: 'groupSequenceContinue',
          hidden: false,
        },
        {
          name: 'groupFieldsFormatter',
          hidden: false,
        },
        {
          name: 'groupFormatter',
          hidden: false,
        },
        {
          name: 'groupFooterFormatter',
          hidden: false,
        },
        {
          name: 'gridColumnsFooterFormatter',
          hidden: false,
        },
      ],
      default: {
        width: 80,
        height: 37,
      },
    },
    // ================ 横线组件配置 ================
    hline: {
      tabs: [
        {
          name: '基础',
          options: [
            {
              name: 'coordinate',
              hidden: false,
            },
            {
              name: 'widthHeight',
              hidden: false,
            },
            {
              name: 'showInPage',
              hidden: false,
            },
            {
              name: 'fixed',
              hidden: false,
            },
          ],
        },
        {
          name: '样式',
          options: [
            {
              name: 'borderWidth',
              hidden: false,
            },
            {
              name: 'borderStyle',
              hidden: false,
            },
            {
              name: 'borderColor',
              hidden: false,
            },
            {
              name: 'transform',
              hidden: false,
            },
            {
              name: 'zIndex',
              hidden: false,
            },
          ],
        },
        {
          name: '高级',
          options: [
            {
              name: 'pageBreak',
              hidden: false,
            },
            {
              name: 'axis',
              hidden: false,
            },
          ],
        },
      ],
      supportOptions: [
        {
          name: 'coordinate',
          hidden: false,
        },
        {
          name: 'widthHeight',
          hidden: false,
        },
        {
          name: 'borderWidth',
          hidden: false,
        },
        {
          name: 'borderStyle',
          hidden: false,
        },
        {
          name: 'borderColor',
          hidden: false,
        },
        {
          name: 'pageBreak',
          hidden: false,
        },
        {
          name: 'showInPage',
          hidden: false,
        },
        {
          name: 'fixed',
          hidden: false,
        },
        {
          name: 'axis',
          hidden: false,
        },
        {
          name: 'transform',
          hidden: false,
        },
        {
          name: 'zIndex',
          hidden: false,
        },
      ],
      default: {
        borderWidth: 0.75,
        height: 9,
        width: 40,
      },
    },
    // ================ 竖线组件配置 ================
    vline: {
      tabs: [
        {
          name: '基础',
          options: [
            {
              name: 'coordinate',
              hidden: false,
            },
            {
              name: 'widthHeight',
              hidden: false,
            },
            {
              name: 'showInPage',
              hidden: false,
            },
            {
              name: 'fixed',
              hidden: false,
            },
          ],
        },
        {
          name: '样式',
          options: [
            {
              name: 'borderWidth',
              hidden: false,
            },
            {
              name: 'borderStyle',
              hidden: false,
            },
            {
              name: 'borderColor',
              hidden: false,
            },
            {
              name: 'transform',
              hidden: false,
            },
            {
              name: 'zIndex',
              hidden: false,
            },
          ],
        },
        {
          name: '高级',
          options: [
            {
              name: 'pageBreak',
              hidden: false,
            },
            {
              name: 'axis',
              hidden: false,
            },
          ],
        },
      ],
      supportOptions: [
        {
          name: 'coordinate',
          hidden: false,
        },
        {
          name: 'widthHeight',
          hidden: false,
        },
        {
          name: 'borderWidth',
          hidden: false,
        },
        {
          name: 'borderStyle',
          hidden: false,
        },
        {
          name: 'borderColor',
          hidden: false,
        },
        {
          name: 'pageBreak',
          hidden: false,
        },
        {
          name: 'showInPage',
          hidden: false,
        },
        {
          name: 'fixed',
          hidden: false,
        },
        {
          name: 'axis',
          hidden: false,
        },
        {
          name: 'transform',
          hidden: false,
        },
        {
          name: 'zIndex',
          hidden: false,
        },
      ],
      default: {
        borderWidth: undefined,
        height: 40,
        width: 9,
      },
    },
    // ================ 矩形组件配置 ================
    rect: {
      tabs: [
        {
          name: '基础',
          options: [
            {
              name: 'coordinate',
              hidden: false,
            },
            {
              name: 'widthHeight',
              hidden: false,
            },
            {
              name: 'showInPage',
              hidden: false,
            },
            {
              name: 'fixed',
              hidden: false,
            },
          ],
        },
        {
          name: '样式',
          options: [
            {
              name: 'borderWidth',
              hidden: false,
            },
            {
              name: 'borderStyle',
              hidden: false,
            },
            {
              name: 'borderColor',
              hidden: false,
            },
            {
              name: 'backgroundColor',
              hidden: false,
            },
            {
              name: 'transform',
              hidden: false,
            },
            {
              name: 'zIndex',
              hidden: false,
            },
          ],
        },
        {
          name: '高级',
          options: [
            {
              name: 'pageBreak',
              hidden: false,
            },
            {
              name: 'axis',
              hidden: false,
            },
          ],
        },
      ],
      supportOptions: [
        {
          name: 'coordinate',
          hidden: false,
        },
        {
          name: 'widthHeight',
          hidden: false,
        },
        {
          name: 'borderWidth',
          hidden: false,
        },
        {
          name: 'borderStyle',
          hidden: false,
        },
        {
          name: 'borderColor',
          hidden: false,
        },
        {
          name: 'backgroundColor',
          hidden: false,
        },
        {
          name: 'pageBreak',
          hidden: false,
        },
        {
          name: 'showInPage',
          hidden: false,
        },
        {
          name: 'fixed',
          hidden: false,
        },
        {
          name: 'axis',
          hidden: false,
        },
        {
          name: 'transform',
          hidden: false,
        },
        {
          name: 'zIndex',
          hidden: false,
        },
      ],
      default: {
        borderWidth: undefined,
        height: 40,
        width: 40,
      },
    },
    // ================ 椭圆组件配置 ================
    oval: {
      tabs: [
        {
          name: '基础',
          options: [
            {
              name: 'coordinate',
              hidden: false,
            },
            {
              name: 'widthHeight',
              hidden: false,
            },
            {
              name: 'showInPage',
              hidden: false,
            },
            {
              name: 'fixed',
              hidden: false,
            },
          ],
        },
        {
          name: '样式',
          options: [
            {
              name: 'borderWidth',
              hidden: false,
            },
            {
              name: 'borderStyle',
              hidden: false,
            },
            {
              name: 'borderColor',
              hidden: false,
            },
            {
              name: 'backgroundColor',
              hidden: false,
            },
            {
              name: 'transform',
              hidden: false,
            },
            {
              name: 'zIndex',
              hidden: false,
            },
          ],
        },
        {
          name: '高级',
          options: [
            {
              name: 'pageBreak',
              hidden: false,
            },
            {
              name: 'axis',
              hidden: false,
            },
          ],
        },
      ],
      supportOptions: [
        {
          name: 'coordinate',
          hidden: false,
        },
        {
          name: 'widthHeight',
          hidden: false,
        },
        {
          name: 'borderWidth',
          hidden: false,
        },
        {
          name: 'borderStyle',
          hidden: false,
        },
        {
          name: 'borderColor',
          hidden: false,
        },
        {
          name: 'backgroundColor',
          hidden: false,
        },
        {
          name: 'pageBreak',
          hidden: false,
        },
        {
          name: 'showInPage',
          hidden: false,
        },
        {
          name: 'fixed',
          hidden: false,
        },
        {
          name: 'axis',
          hidden: false,
        },
        {
          name: 'transform',
          hidden: false,
        },
        {
          name: 'zIndex',
          hidden: false,
        },
      ],
      default: {
        borderWidth: undefined,
        height: 30,
        width: 40,
      },
    },
    // ================ html组件配置 ================
    html: {
      tabs: [
        {
          name: '基础',
          options: [
            {
              name: 'coordinate',
              hidden: false,
            },
            {
              name: 'widthHeight',
              hidden: false,
            },
            {
              name: 'showInPage',
              hidden: false,
            },
            {
              name: 'unShowInPage',
              hidden: false,
            },
            {
              name: 'fixed',
              hidden: false,
            },
          ],
        },
        {
          name: '样式',
          options: [
            {
              name: 'transform',
              hidden: false,
            },
            {
              name: 'zIndex',
              hidden: false,
            },
          ],
        },
        {
          name: '高级',
          options: [
            {
              name: 'pageBreak',
              hidden: false,
            },
            {
              name: 'axis',
              hidden: false,
            },
            {
              name: 'formatter',
              hidden: false,
            },
          ],
        },
      ],
      supportOptions: [
        {
          name: 'coordinate',
          hidden: false,
        },
        {
          name: 'widthHeight',
          hidden: false,
        },
        {
          name: 'pageBreak',
          hidden: false,
        },
        {
          name: 'showInPage',
          hidden: false,
        },
        {
          name: 'unShowInPage',
          hidden: false,
        },
        {
          name: 'fixed',
          hidden: false,
        },
        {
          name: 'zIndex',
          hidden: false,
        },
        {
          name: 'axis',
          hidden: false,
        },
        {
          name: 'formatter',
          hidden: false,
        },
      ],
      default: {
        height: 40,
        width: 90,
      },
    },
    // ================ 表格列组件配置 ================
    tableColumn: {
      supportOptions: [
        {
          name: 'title',
          hidden: false,
        },
        {
          name: 'align',
          hidden: false,
        },
        {
          name: 'halign',
          hidden: false,
        },
        {
          name: 'vAlign',
          hidden: false,
        },
        {
          name: 'tableTextType',
          hidden: false,
        },
        {
          name: 'tableBarcodeMode',
          hidden: false,
        },
        {
          name: 'tableQRCodeLevel',
          hidden: false,
        },
        {
          name: 'tableColumnHeight',
          hidden: false,
        },
        {
          // 表格条码底部是否显示内容
          name: 'showCodeTitle',
          hidden: false,
        },
        {
          name: 'paddingLeft',
          hidden: false,
        },
        {
          name: 'paddingRight',
          hidden: false,
        },
        {
          name: 'tableSummaryTitle',
          hidden: false,
        },
        {
          name: 'tableSummaryText',
          hidden: false,
        },
        {
          name: 'tableSummaryColspan',
          hidden: false,
        },
        {
          name: 'tableSummary',
          hidden: false,
        },
        {
          name: 'tableSummaryAlign',
          hidden: false,
        },
        {
          name: 'tableSummaryNumFormat',
          hidden: false,
        },

        {
          name: 'tableSummaryFormatter',
          hidden: false,
        },
        {
          name: 'upperCase',
          hidden: false,
        },

        {
          name: 'renderFormatter',
          hidden: false,
        },
        {
          name: 'formatter2',
          hidden: false,
        },
        {
          name: 'styler2',
          hidden: false,
        },
        {
          name: 'stylerHeader',
          hidden: false,
        },
      ],
      default: {
        height: 90,
        width: 90,
      },
    },
    // ================ 条码组件配置 ================
    barcode: {
      tabs: [
        {
          name: '基础',
          options: [
            {
              name: 'title',
              hidden: false,
            },
            {
              name: 'field',
              hidden: true,
            },
            {
              name: 'testData',
              hidden: false,
            },
            {
              name: 'barcodeType',
              hidden: false,
            },
            {
              name: 'barWidth',
              hidden: false,
            },
            {
              name: 'barAutoWidth',
              hidden: false,
            },
            {
              name: 'coordinate',
              hidden: false,
            },
            {
              name: 'widthHeight',
              hidden: false,
            },
            {
              name: 'hideTitle',
              hidden: false,
            },
            {
              name: 'fixed',
              hidden: false,
            },
          ],
        },
        {
          name: '样式',
          options: [
            {
              name: 'fontFamily',
              hidden: false,
            },
            {
              name: 'fontSize',
              hidden: false,
            },
            {
              name: 'fontWeight',
              hidden: false,
            },
            {
              name: 'letterSpacing',
              hidden: false,
            },
            {
              name: 'color',
              hidden: false,
            },
            {
              name: 'backgroundColor',
              hidden: false,
            },
            {
              name: 'barColor',
              hidden: false,
            },
            {
              name: 'textAlign',
              hidden: false,
            },
            {
              name: 'textContentVerticalAlign',
              hidden: false,
            },
            {
              name: 'lineHeight',
              hidden: false,
            },
            {
              name: 'transform',
              hidden: false,
            },
            {
              name: 'zIndex',
              hidden: false,
            },
          ],
        },
        {
          name: '高级',
          options: [
            {
              name: 'pageBreak',
              hidden: false,
            },
            {
              name: 'showInPage',
              hidden: false,
            },
            {
              name: 'unShowInPage',
              hidden: false,
            },
            {
              name: 'axis',
              hidden: false,
            },
            {
              name: 'formatter',
              hidden: false,
            },
            {
              name: 'styler',
              hidden: false,
            },
          ],
        },
      ],
      supportOptions: [
        {
          name: 'title',
          hidden: false,
        },
        {
          name: 'field',
          hidden: true,
        },
        {
          name: 'testData',
          hidden: false,
        },
        {
          name: 'barcodeType',
          hidden: false,
        },
        {
          name: 'barWidth',
          hidden: false,
        },
        {
          name: 'barAutoWidth',
          hidden: false,
        },
        {
          name: 'coordinate',
          hidden: false,
        },
        {
          name: 'widthHeight',
          hidden: false,
        },
        {
          name: 'hideTitle',
          hidden: false,
        },
        {
          name: 'fixed',
          hidden: false,
        },
        {
          name: 'fontFamily',
          hidden: false,
        },
        {
          name: 'fontSize',
          hidden: false,
        },
        {
          name: 'fontWeight',
          hidden: false,
        },
        {
          name: 'letterSpacing',
          hidden: false,
        },
        {
          name: 'color',
          hidden: false,
        },
        {
          name: 'backgroundColor',
          hidden: false,
        },
        {
          name: 'barColor',
          hidden: false,
        },
        {
          name: 'textAlign',
          hidden: false,
        },
        {
          name: 'textContentVerticalAlign',
          hidden: false,
        },
        {
          name: 'lineHeight',
          hidden: false,
        },
        {
          name: 'transform',
          hidden: false,
        },
        {
          name: 'zIndex',
          hidden: false,
        },
        {
          name: 'pageBreak',
          hidden: false,
        },
        {
          name: 'showInPage',
          hidden: false,
        },
        {
          name: 'unShowInPage',
          hidden: false,
        },
        {
          name: 'axis',
          hidden: false,
        },
        {
          name: 'formatter',
          hidden: false,
        },
        {
          name: 'styler',
          hidden: false,
        },
      ],
      default: {
        width: 120,
        height: 30,
        title: '条形码',
        barcodeType: 'code128',
        testData: 'barcode',
        // barAutoWidth: 'true' 这里必须使用字符串
      },
    },
    // ================ 二维码组件配置 ================
    qrcode: {
      tabs: [
        {
          name: '基础',
          options: [
            {
              name: 'title',
              hidden: false,
            },
            {
              name: 'field',
              hidden: true,
            },
            {
              name: 'testData',
              hidden: false,
            },
            {
              name: 'qrcodeType',
              hidden: false,
            },
            {
              name: 'qrCodeLevel',
              hidden: false,
            },
            {
              name: 'coordinate',
              hidden: false,
            },
            {
              name: 'widthHeight',
              hidden: false,
            },
            {
              name: 'hideTitle',
              hidden: false,
            },
            {
              name: 'fixed',
              hidden: false,
            },
          ],
        },
        {
          name: '样式',
          options: [
            {
              name: 'fontFamily',
              hidden: false,
            },
            {
              name: 'fontSize',
              hidden: false,
            },
            {
              name: 'fontWeight',
              hidden: false,
            },
            {
              name: 'letterSpacing',
              hidden: false,
            },
            {
              name: 'color',
              hidden: false,
            },
            {
              name: 'backgroundColor',
              hidden: false,
            },
            {
              name: 'barColor',
              hidden: false,
            },
            {
              name: 'textAlign',
              hidden: false,
            },
            {
              name: 'textContentVerticalAlign',
              hidden: false,
            },
            {
              name: 'lineHeight',
              hidden: false,
            },
            {
              name: 'transform',
              hidden: false,
            },
            {
              name: 'zIndex',
              hidden: false,
            },
          ],
        },
        {
          name: '高级',
          options: [
            {
              name: 'pageBreak',
              hidden: false,
            },
            {
              name: 'showInPage',
              hidden: false,
            },
            {
              name: 'unShowInPage',
              hidden: false,
            },
            {
              name: 'axis',
              hidden: false,
            },
            {
              name: 'formatter',
              hidden: false,
            },
            {
              name: 'styler',
              hidden: false,
            },
          ],
        },
      ],
      supportOptions: [
        {
          name: 'title',
          hidden: false,
        },
        {
          name: 'field',
          hidden: true,
        },
        {
          name: 'testData',
          hidden: false,
        },
        {
          name: 'qrcodeType',
          hidden: false,
        },
        {
          name: 'qrCodeLevel',
          hidden: false,
        },
        {
          name: 'coordinate',
          hidden: false,
        },
        {
          name: 'widthHeight',
          hidden: false,
        },
        {
          name: 'hideTitle',
          hidden: false,
        },
        {
          name: 'fixed',
          hidden: false,
        },
        {
          name: 'fontFamily',
          hidden: false,
        },
        {
          name: 'fontSize',
          hidden: false,
        },
        {
          name: 'fontWeight',
          hidden: false,
        },
        {
          name: 'letterSpacing',
          hidden: false,
        },
        {
          name: 'color',
          hidden: false,
        },
        {
          name: 'backgroundColor',
          hidden: false,
        },
        {
          name: 'barColor',
          hidden: false,
        },
        {
          name: 'textAlign',
          hidden: false,
        },
        {
          name: 'textContentVerticalAlign',
          hidden: false,
        },
        {
          name: 'lineHeight',
          hidden: false,
        },
        {
          name: 'transform',
          hidden: false,
        },
        {
          name: 'zIndex',
          hidden: false,
        },
        {
          name: 'pageBreak',
          hidden: false,
        },
        {
          name: 'showInPage',
          hidden: false,
        },
        {
          name: 'unShowInPage',
          hidden: false,
        },
        {
          name: 'axis',
          hidden: false,
        },
        {
          name: 'formatter',
          hidden: false,
        },
        {
          name: 'styler',
          hidden: false,
        },
      ],
      default: {
        width: 90,
        height: 60,
        title: '二维码',
        qrcodeType: 'qrcode',
        testData: 'qrcode',
      },
    },
  }
})()
